const currentSearchSingletonModel = require('od-modules/models/current_search.singleton.model');
const tripTypeUtils = require('od-modules/utils/trip_type');
const viewInjector = require('../view_injector');

const containers = {
    time: '.time_filter_container',
    stops: '.stops_filter_container',
    airports: '.airports_filter_container',
    airlines: '.airlines_filter_container',
    paymentMethod: '.payment_method_filter_container',
};

const widgets = Odigeo.autoloadWidgets(Odigeo._.extend({
    timeFilter: ['time-filter-${0}', 'time_filter'],
    airlinesFilter: ['airlines-filter-${0}', 'airlines_filter'],
    airportsFilter: ['airports-filter-${0}', 'airports_filter'],
}));

const replaceCmsKeyArgs = Odigeo.Utils.replaceCmsKeyArgs;
const template = function(text) {
    return Odigeo._.template(text, Odigeo.Utils.getTmplSettings({variable: ''}));
};
const createContainerTemplate = function(text, keyArgs) {
    return function(data) {
        const replacedText = replaceCmsKeyArgs.apply(null, [text].concat(keyArgs));
        return Odigeo.Utils.pluralizeAll(template(replacedText)(data));
    };
};
const createTimeContainerTemplate = function(translations) {
    const minDepartureDateLabel = '{{ minDepartureDate }}';
    const maxDepartureDateLabel = '{{ maxDepartureDate }}';
    const defaultTemplate = createContainerTemplate(translations.time, [minDepartureDateLabel, maxDepartureDateLabel]);
    const roundTripTemplate = createContainerTemplate(translations.roundTripTime, ['{{ index }}', minDepartureDateLabel, maxDepartureDateLabel]);
    return function(data) {
        const isRoundTrip = tripTypeUtils.isRoundTrip(currentSearchSingletonModel.getInstance().get('type'));
        return isRoundTrip ? roundTripTemplate(data) : defaultTemplate(data);
    };
};

const isTimesUnselected = function(model) {
    const wayTimeFilter = ['Arrival', 'Departure'];
    return (wayTimeFilter.some((way) => {
        return ((model.get(`selectedMin${way}Date`) < model.get(`min${way}Date`) &&
            model.get(`selectedMax${way}Date`) < model.get(`min${way}Date`)) ||
            (model.get(`selectedMin${way}Date`) > model.get(`max${way}Date`) &&
                model.get(`selectedMax${way}Date`) > model.get(`max${way}Date`)));
    })
    );
};
const isAllTimesUnselected = function(numberOfIdx) {
    let isZeroSelected = false;
    for (let i = 0; i < numberOfIdx && !isZeroSelected; i++) {
        isZeroSelected = isTimesUnselected(widgets.timeFilter(i).model);
    }
    return isZeroSelected;
};
const isAirportsUnselected = function(numberOfIdx) {
    let isZeroSelected = false;
    let origin = '';
    let destination = '';
    let isOriginUnchecked = false;
    let isDestinationUnchecked = false;
    for (let i = 0; i < numberOfIdx && !isZeroSelected; i++) {
        origin = widgets.airportsFilter(i).model.get('origin').models[0].get('airportCollection');
        destination = widgets.airportsFilter(i).model.get('destination').models[0].get('airportCollection');
        isOriginUnchecked = origin.models.every( (e) => !e.get('active'));
        isDestinationUnchecked = destination.models.every( (e) => !e.get('active'));
        isZeroSelected = ( isOriginUnchecked || isDestinationUnchecked );
    }
    return isZeroSelected;
};
const isAirlinesUnselected = function(numberOfIdx) {
    let isZeroSelected = false;
    for (let i = 0; i < numberOfIdx && !isZeroSelected; i++) {
        isZeroSelected = (widgets.airlinesFilter(i).model.get('airlines').numSelected === 0);
    }
    return isZeroSelected;
};
module.exports = {

    createContainerTemplates: function() {
        const translations = this.widget.options.translations;
        return {
            time: createTimeContainerTemplate(translations),
            stopoverQuantity: createContainerTemplate(translations.stopoverQuantity, ['{{ maxStopoversSelected }}']),
            stopoverDuration: createContainerTemplate(translations.stopoverDuration, ['{{ selectedStopDuration }}']),
            baggage: createContainerTemplate(translations.baggage, []),
            airports: createContainerTemplate(translations.airports, ['{{ airportName }}', '{{ numSelected - 1 }}']),
            airlines: createContainerTemplate(translations.airlines, ['{{ airlineName }}', '{{ numSelected - 1 }}']),
            paymentMethod: Odigeo._.constant(''),
        };
    },
    createContainerViews: function() {
        const model = this.model;
        const numberOfTabs = this.widget.numFlights;

        Odigeo._.each(containers, Odigeo._.bind(function(selector, containerName) {
            const filterSummaryModel = model.get(containerName);
            filterSummaryModel.get('filterSummary').clear(numberOfTabs);
            this.createView(containerName, viewInjector(this).create('filterContainer', {
                numberOfTabs: numberOfTabs,
                model: filterSummaryModel,
                name: containerName,
                el: selector,
            }));
        }, this));
    },
    setFilterTitleActive: function(triggeredFilter, isFilterOptionsUnselected) {
        const {isFiltered, titleContainer} = triggeredFilter;
        const summaryLabelContainer = titleContainer.next().find('.summary_label');
        summaryLabelContainer.toggleClass('odf-hidden', isFilterOptionsUnselected);
        titleContainer.toggleClass('odf-text-negative', (isFilterOptionsUnselected && isFiltered));
        titleContainer.toggleClass('odf-text-primary', (!isFilterOptionsUnselected && isFiltered));
    },

    isFilterOptionsUnselected: function(container) {
        let numberOfIdx = 0;
        (tripTypeUtils.isRoundTrip(this.widget.tripType) && container === 'time') ?
            numberOfIdx = this.model.get(container).get('filterSummary').models[0].get('tags').length :
            numberOfIdx = this.model.get(container).get('filterSummary').length;
        const filterContainers = ['time', 'airports', 'airlines'];
        const triggerFiltersCheck = {
            'time': isAllTimesUnselected,
            'airports': isAirportsUnselected,
            'airlines': isAirlinesUnselected,
        };
        return filterContainers.includes(container) && triggerFiltersCheck[container](numberOfIdx);
    },
};
